import {
  OWNER_SCOPE_VALUES,
  buildCsmScope,
  isOwnCsmScope,
} from "../../utils/ownerScope";

// An admin's own entry is left out of the CSM list (PAN-592): "My Customers" is the same
// book, since the server resolves owner_scope=mine and cs_owner_id=<own id> to the same user
// on every endpoint while the admin is in the CSM list (outside it, cs_owner_id=<own id> is a
// 400 and the entry is not listed anyway). Until the current user is known, nothing is left out.
export const getScopeOptions = ({
  isAdmin,
  csmViewMode,
  csms,
  currentUserId = null,
}) => {
  if (!isAdmin && csmViewMode === "restricted") {
    return [];
  }

  const options = [
    { value: OWNER_SCOPE_VALUES.ALL, label: "All Customers" },
    { value: OWNER_SCOPE_VALUES.MINE, label: "My Customers" },
  ];

  if (!isAdmin) {
    return options;
  }

  return [
    ...options,
    ...csms
      .filter((c) => !isOwnCsmScope(buildCsmScope(c.id), currentUserId))
      .map((c) => ({
        value: buildCsmScope(c.id),
        label: c.name + (c.is_placeholder ? " (not on Panora)" : ""),
        isPlaceholder: c.is_placeholder,
      })),
  ];
};

export const resolveEffectiveScope = ({
  stored,
  isAdmin,
  csmViewMode,
  csmIds,
  currentUserId = null,
}) => {
  if (!isAdmin && csmViewMode === "restricted") {
    return OWNER_SCOPE_VALUES.MINE;
  }

  if (!stored) {
    return isAdmin ? OWNER_SCOPE_VALUES.ALL : OWNER_SCOPE_VALUES.MINE;
  }

  if (typeof stored === "string" && stored.startsWith("csm:")) {
    // Only admins may hold another CSM's book (server enforces it too, PAN-238/417); a
    // demoted admin or a shared browser must not carry a "csm:" scope the select cannot
    // show. Fall back to the role default.
    if (!isAdmin) {
      return OWNER_SCOPE_VALUES.MINE;
    }
    // The admin's own entry is no longer offered; "My Customers" is the same accounts while the
    // admin is in the CSM list, and the stored value is refused (400) when they are not.
    if (isOwnCsmScope(stored, currentUserId)) {
      return OWNER_SCOPE_VALUES.MINE;
    }
    if (!csmIds.includes(stored.slice(4))) {
      return OWNER_SCOPE_VALUES.ALL;
    }
  }

  return stored;
};
